<ng-container *ngIf="resourceUrl">
    <iframe style="width: 100%;min-height: 320px;position: relative;" [src]="resourceUrl | safe:'resourceUrl'"
            frameborder="0" allowfullscreen (load)="onLoad()">
    </iframe>
</ng-container>